/**
 * Словник: uk.
 * Згенеровано tool/gen_web_locales.py з lib/l10n/app_uk.arb — руками не правити.
 *
 * ⚠️ Новий рядок: спершу в ARB усіх мов, потім ключ у en.ts і перегенерація.
 * Паритет ключів перевіряється на збірці (npm run check:i18n).
 */
export default {
  waiting: "⏳ Очікування іншого учасника...",
  connectionLost: "З'єднання втрачено",
  peerLeft: "👋 Інший учасник покинув дзвінок",
  connectionError: "🚫 Помилка з'єднання",
  connectionFailedTryAgain: "🚫 Не вдалось підключитись до сервера. Спробуйте ще раз.",
  reconnectionFailed: "🚫 З'єднання втрачено. Не вдалося відновити після {attempts} спроб.",
  connectionErrorWithDetails: "🚫 Помилка з’єднання: {error}",
  speakerLoud: "Гучно",
  speakerEar: "Вухо",
  copyRoomId: "Копіювати ID кімнати",
  share: "Поділитися",
  linkCopied: "🔗 Посилання скопійовано!",
  idCopied: "🆔 ID скопійовано!",
  startMeeting: "Почати зустріч",
  chooseAction: "Виберіть дію",
  createNewRoom: "Нова кімната",
  scheduleCall: "Запланувати дзвінок",
  calendarOpened: "📅 Календар успішно відкрито",
  linkCopiedToClipboard: "🔗 Посилання скопійовано в буфер обміну",
  enterRoomId: "Введіть ID кімнати",
  roomIdValidationError: "ID кімнати може містити тільки літери, цифри та дефіс",
  joinRoom: "ПРИЄДНАТИСЬ",
  termsAndPrivacyHelp: "Умови та конфіденційність | Допомога",
  invite: "Запросити",
  mySettings: "Мої налаштування",
  peerSettings: "Його налаштування",
  blockRemoteControl: "Заблокувати віддалене управління",
  iAgreeToTerms: "Я погоджуюся з правилами сервісу",
  termsOfUse: "Умови використання",
  privacyPolicy: "Політика конфіденційності",
  howToUse: "Як користуватись",
  termsAcceptanceRequired: "Для використання сервісу необхідно погодитися з правилами",
  ok: "ОК",
  permissionsRequired: "Потрібні дозволи",
  permissionsNeededMessage: "Цей додаток потребує наступних дозволів для правильної роботи:",
  permissionsNote: "Примітка: При зміні дозволів в Налаштуваннях iOS перезапустить додаток. Це нормальна поведінка.",
  permissionsEnableMessage: "Будь ласка, увімкніть ці дозволи в налаштуваннях пристрою, щоб продовжити.",
  cancel: "Скасувати",
  openSettings: "Відкрити налаштування",
  websocketError: "Помилка WebSocket",
  roomFull: "Кімната заповнена",
  timeExpired: "Час вичерпався",
  remaining: "зал.",
  mediaPermissionsRequired: "Для відеодзвінків потрібен доступ до камери та мікрофона. Будь ласка, надайте дозволи в браузері.",
  mediaPermissionsRequiredMobile: "Для відеодзвінків потрібен доступ до камери та мікрофона. Будь ласка, надайте дозволи в налаштуваннях додатку.",
  browserSettings: "Налаштування браузера",
  openAppSettings: "Відкрити налаштування",
  grantPermissions: "Надати дозволи",
  permissionsNotGranted: "Дозволи не надані. Будь ласка, надайте дозволи для продовження.",
  permissionRequestError: "Помилка при запиті дозволів: {error}",
  camera: "Камера",
  microphone: "Мікрофон",
  cameraDescription: "Для передачі відео",
  microphoneDescription: "Для передачі аудіо",
  continueWithoutPermissions: "Продовжити без дозволів",
  mediaPermissionsRequiredFallback: "Для відеодзвінків потрібен доступ до камери та мікрофона. Будь ласка, надайте дозволи в налаштуваннях браузера.",
  mediaPermissionsRequiredMobileFallback: "Для відеодзвінків потрібен доступ до камери та мікрофона. Будь ласка, надайте дозволи в налаштуваннях додатку.",
  browserSettingsFallback: "Налаштування браузера",
  openAppSettingsFallback: "Відкрити налаштування",
  permissionsPermanentlyDenied: "Дозволи відхилені назавжди. Будь ласка, увімкніть їх в налаштуваннях додатку.",
  continueText: "Продовжити",
  mirror: "Дзеркало",
  fitContain: "Вмістити",
  fitCover: "Заповнити",
  switchCamera: "Камера",
  block: "Заблок.",
  pip: "PiP",
  mic: "Мік",
  video: "Відео",
  speaker: "Динамік",
  readyToConnect: "Готові спілкуватись?",
  startOneOnOne: "Почати відеодзвінок",
  createPrivateLink: "Посилання — за секунду",
  welcomeExplainer: "Створіть посилання й надішліть його будь-кому. Воно відкривається навіть без застосунку.",
  joinHaveLink: "Маєте посилання?",
  joinFieldHint: "Вставте посилання або ID",
  roomInputInvalid: "Вставте посилання на дзвінок або ID кімнати (літери, цифри й дефіс)",
  guestTitle: "Вас запрошують на відеодзвінок",
  guestBody: "Кімната готова. Співрозмовник побачить вас, щойно ви приєднаєтесь.",
  guestJoin: "Приєднатися",
  guestFreeNote: "Приєднання завжди безкоштовне",
  guestCreateOwn: "Створити свою кімнату",
  guestInvalidTitle: "Посилання пошкоджене",
  guestInvalidBody: "Попросіть надіслати посилання ще раз або створіть свою кімнату.",
  inviteCardTitle: "Кімната готова",
  inviteCardBody: "Надішліть посилання тому, з ким хочете поговорити",
  inviteShareLink: "Поділитися посиланням",
  inviteCopy: "Копіювати",
  inviteBrowserHint: "Відкриється в будь-якому браузері. Встановлювати застосунок не треба.",
  inviteSentHint: "Надіслали? Співрозмовник зʼявиться тут, щойно відкриє посилання.",
  inviteShareMessage: "Привіт! Приєднуйся до відеодзвінка в One2One 👋\nПросто відкрий посилання. Воно працює в браузері, нічого встановлювати не треба:\n{link}",
  copyLink: "Копіювати посилання",
  consentBannerText: "Дозволите збирати статистику використання? Вона показує, якими функціями користуються. Вміст дзвінків туди не потрапляє ніколи.",
  consentAllow: "Дозволити",
  consentDeny: "Не дозволяти",
  privacySettingsLink: "Налаштування статистики",
} as const;
